import { Component } from '@angular/core';

@Component({
  selector: 'app-reminder-icon',
  imports: [],
  templateUrl: './reminder-icon.html',
  styleUrl: './reminder-icon.css'
})
export class ReminderIcon {

}
